module.exports = __webpack_public_path__ + "img/premium-bg.87b677aa.svg";